import { render, staticRenderFns } from "./SupportTicketsCard.vue?vue&type=template&id=67a8d92e&scoped=true"
import script from "./SupportTicketsCard.vue?vue&type=script&lang=js"
export * from "./SupportTicketsCard.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketsCard.vue?vue&type=style&index=0&id=67a8d92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8d92e",
  null
  
)

export default component.exports